"use strict";

exports.__esModule = true;
exports["default"] = exports.HtmlWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["children", "position"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var WrapperElement = (0, _styledComponents["default"])(_gridSystem["default"].Element).withConfig({
  displayName: "wrappers__WrapperElement",
  componentId: "sc-1nzr59m-0"
})(["", ";"], function (_ref) {
  var position = _ref.position;
  return position === "left" || position === "right" ? "float: " + position + ";" : null;
});
var positionStyles = {
  full: {
    columns: [6, 8, 12]
  },
  inline: {
    columns: [6, 8, 7.5, 8]
  },
  left: {
    columns: [6, 8, 7.5, 4]
  },
  middle: {
    columns: [6, 8, 7.5, 8]
  },
  none: {
    columns: null,
    m: 0,
    p: 0,
    pl: 0
  },
  right: {
    columns: [6, 8, 4.5, 4]
  }
};
var propTypes = {
  /** children renders as node  */
  children: _propTypes.node,

  /** element position  */
  position: _propTypes.string
};

var HtmlWrapper = function HtmlWrapper(_ref2) {
  var children = _ref2.children,
      _ref2$position = _ref2.position,
      position = _ref2$position === void 0 ? "none" : _ref2$position,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/_react["default"].createElement(WrapperElement, _extends({
    position: position
  }, props, positionStyles[position]), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    width: 1
  }, children));
};

exports.HtmlWrapper = HtmlWrapper;
HtmlWrapper.propTypes = propTypes;
var _default = HtmlWrapper;
exports["default"] = _default;